// src/views/Dropzone/DropzoneContent/DropzoneContent.tsx
import { Flex, Text } from "@chakra-ui/react";
import { useMobileDetect } from "@airhelp/use-mobile-detect";
import { ImageDrop } from "@airhelp/illustrations";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var DropzoneContent = ({
  selectText,
  supportedFilesText,
  uploadText,
  isDropzoneActive,
  dropText
}) => {
  const isMobile = useMobileDetect();
  return /* @__PURE__ */ jsxs(Flex, {
    direction: { base: "row", md: "column" },
    flex: "1",
    justify: { base: "flex-start", md: "center" },
    align: "center",
    children: [
      /* @__PURE__ */ jsx(Flex, {
        bg: "transparent",
        boxSize: "96px",
        direction: "column",
        justify: "center",
        align: "center",
        children: /* @__PURE__ */ jsx(Flex, {
          bg: "primary.400",
          boxSize: 12,
          borderRadius: "50%",
          justify: "center",
          align: "center",
          children: /* @__PURE__ */ jsx(ImageDrop, {
            color: isDropzoneActive ? "greyscale.100" : "primary.100",
            boxSize: { base: "72px", md: "96px" }
          })
        })
      }),
      /* @__PURE__ */ jsx(Flex, {
        direction: "column",
        alignItems: { base: "flex-start", md: "center" },
        justifyContent: "center",
        flexWrap: "wrap",
        children: isDropzoneActive ? /* @__PURE__ */ jsx(Text, {
          fontSize: "lg",
          color: "primary.900",
          fontWeight: "medium",
          as: "div",
          children: isMobile ? uploadText : dropText
        }) : /* @__PURE__ */ jsxs(Fragment, {
          children: [
            /* @__PURE__ */ jsx(Text, {
              sx: {
                span: {
                  color: "primary.500"
                }
              },
              fontSize: { base: "sm", md: "lg" },
              fontWeight: "medium",
              mt: { base: 0, md: 3 },
              color: isMobile ? "primary.500" : "primary.900",
              as: "div",
              children: isMobile ? uploadText : selectText
            }),
            /* @__PURE__ */ jsx(Text, {
              fontSize: "sm",
              color: "greyscale.600",
              fontWeight: "normal",
              mt: { base: 0, md: 1 },
              maxW: { base: "224px", md: "unset" },
              children: supportedFilesText
            })
          ]
        })
      })
    ]
  });
};

export {
  DropzoneContent
};
